import React from 'react';
import { DataGrid } from 'devextreme-react';
import { ActionBarContext } from 'utils/ActionBarContextProvider';
import { Paper, withStyles } from '@material-ui/core';
import styles from './Commit.styles';
import { ILinesProperties } from './Commit.properties';
import { createDataSource } from 'components/common/DataGridDevEx/DataGrid.hooks';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import { ActionBarIcons, columns, LineCommitmentHeaderFilterHeight, LineCommitmentHeaderFilterWidth, quantityFilter } from './Commit.constants';
import { useRetrievePurchaseOrdersCommitLines } from 'api/purchaseOrders/purchaseOrders';
import { setActionBarFn } from '../OrderDetails/OrderDetails.properties';
import { usePOContextSelector, usePODispatch } from '../PurchaseOrders.context';

const setActionBarButtons = (setActionBarCallBack: setActionBarFn): void => { setActionBarCallBack(ActionBarIcons); };

const Commit = (props: ILinesProperties) => {
    const { classes, changeSelectedTab } = props;
    const { setActionBar } = React.useContext(ActionBarContext);

    const params = new URLSearchParams(location.search);
    const PurchaseOrderId = usePOContextSelector<'PurchaseOrder'>((state) => state.PurchaseOrder) || params.get('PurchaseOrder');

    const fetchLinesMutation = useRetrievePurchaseOrdersCommitLines();
    const contextDispatch = usePODispatch();

    const dataGridInnerRef = React.useRef<DataGrid>();

    const fetch = React.useCallback(
        async (BatchPage, BatchSize, Sort) => {
            if (PurchaseOrderId !== undefined && PurchaseOrderId !== null && PurchaseOrderId !== '' && PurchaseOrderId.toString() !== 'NaN') {
                try {
                    const lines = await fetchLinesMutation.mutateAsync({
                        PurchaseOrder: PurchaseOrderId || '',
                        urlQueryParams: {
                            BatchPage,
                            BatchSize,
                            Sort,
                            CommitQuantityFilter: quantityFilter(dataGridInnerRef?.current?.instance?.getCombinedFilter()?.flat()),
                        }
                    });

                    return lines?.OutstandingPurchaseOrderLines;
                } catch (error) {
                    console.error('Error fetching lines:', error);

                    return null;
                }
            } else {
                return null;
            }
        },
        [PurchaseOrderId, dataGridInnerRef?.current]
    );

    const linesDataSource = React.useMemo(
        () => createDataSource('LineNumber', { fetch }),
        [fetch]
    );

    React.useEffect(
        () => { setActionBarButtons(setActionBar); },
        []
    );

    const detailOnClick = React.useCallback(
        ({ data }) => {
            changeSelectedTab('PurchaseOrderLineCommitments', {
                search: {
                    PurchaseOrder: data.PurchaseOrder,
                    LineNumber: data.LineNumber
                }
            });
            contextDispatch({
                setPurchaseOrder: data.PurchaseOrder,
                setLineNumber: data.LineNumber
            });
        },
        [changeSelectedTab]
    );

    return (
        <div className={classes.parentContainer}>
            <Paper className={classes.gridContainer}>
                <DynamicDataGrid
                    dataGridClassName={classes.grid}
                    columns={columns}
                    allowHeaderFilting={true}
                    allowUpdating={false}
                    allowDelete={false}
                    actionButtonsVisibility={false}
                    gridProps={{
                        dataSource: linesDataSource,
                        dataGridRef: dataGridInnerRef,
                        sorting: { mode: 'single' },
                        headerFilterHeight: LineCommitmentHeaderFilterHeight,
                        headerFilterWidth: LineCommitmentHeaderFilterWidth
                    }}
                    detailOnClick={detailOnClick}
                />
            </Paper>
        </div>
    );
};

export default withStyles(styles, { index: 1 })(React.memo(React.forwardRef(Commit)));
